import { Component, Input, OnInit } from '@angular/core';

import { PasswordValidatorErrors, PasswordValidatorOptions } from 'src/app/@shared/password.validator';

@Component({
  providers: [],
  selector: 'proto-password-validation',
  standalone: false,
  styleUrls: ['./password-validation.component.scss'],
  templateUrl: './password-validation.component.html',
})
export class PasswordValidationComponent implements OnInit {
  @Input() public passwordOptions: PasswordValidatorOptions;
  @Input() public passwordErrors: PasswordValidatorErrors;

  public options: any[] = [];

  public ngOnInit(): void {
    const options = [];

    for (const key of Object.keys(this.passwordOptions)) {
      const option = {
        id: key,
        order: this.passwordOptions[key].order || 0,
        text: this.passwordOptions[key].text,
      };

      options.push(option);
    }

    options.sort((a, b) => { return a.order - b.order; });

    this.options = options;
  }
}
